import { render, staticRenderFns } from "./mortgageSearch.vue?vue&type=template&id=35f4a134&scoped=true&lang=html&"
import script from "./mortgageSearch.vue?vue&type=script&lang=js&"
export * from "./mortgageSearch.vue?vue&type=script&lang=js&"
import style0 from "./mortgageSearch.vue?vue&type=style&index=0&id=35f4a134&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f4a134",
  null
  
)

export default component.exports